import { TabView, TabPanel } from "primereact/tabview";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import { SubmissionHistoryList } from "./SubmissionHistoryList";
import { SubmissionHistoryDetail } from "./SubmissionHistoryDetail";
import { JobsInQueue } from "./JobsInQueue";
import { Enrichment } from "./Enrichment";
import { useLocalUser } from "../../data";
import { useFeatureEnabled } from "../../../../IfFeatureEnabled";

const SubmissionHistoryTabs = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  // Dropping the tab rather than disabling it keeps the tab-index to route
  // mapping correct for everyone who cannot see it.
  const showEnrichment = useFeatureEnabled(
    "bulk-enrichment",
    undefined,
    useLocalUser()
  );
  const tabs = showEnrichment
    ? ["activity", "queue", "enrichment"]
    : ["activity", "queue"];
  const activeIndex = Math.max(0, tabs.indexOf(tab ?? ""));

  return (
    <TabView
      activeIndex={activeIndex}
      onTabChange={(e) => navigate(`../${tabs[e.index]}`, { replace: true })}
    >
      <TabPanel header="Activity Log">
        <SubmissionHistoryList />
      </TabPanel>
      <TabPanel header="Jobs in Queue">
        <JobsInQueue />
      </TabPanel>
      {showEnrichment && (
        <TabPanel header="Enrichment">
          <Enrichment />
        </TabPanel>
      )}
    </TabView>
  );
};

export const SubmissionHistory = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="activity" replace />} />
      <Route path=":tab" element={<SubmissionHistoryTabs />} />
      <Route path="detail/:reportId" element={<SubmissionHistoryDetail />} />
    </Routes>
  );
};
